import CInterview from '@/views/staff/interview/components/view.vue'
import CSettlement from '@/views/worker/SalarySettlement/components/view.vue'
import CTurnSite from '@/views/worker/flow/turnSiteApply/components/view.vue'
import CLeaveJob from '@/views/worker/flow/leaveJob/components/view.vue'
import CCourseApplication from '@/views/worker/flow/courseApplication/components/view.vue'
import CCourse from '@/views/worker/flow/course/components/view.vue'
import CTransferDormitory from '@/views/worker/flow/transferDormitory/components/view.vue'
import CPassportApplication from '@/views/worker/flow/passportApplication/components/view.vue'
import CVIewPage from '@/views/apply/components/viewPage.vue'
import CVEditPage from '@/views/apply/components/editViewPage.vue'
import CVIew from '@/views/worker/apply/components/view.vue'

const workerProcessOption = {
  17: {
    component: 'CTurnSite',
    params: [
      {
        key: 'processId',
        value: 'processId',
      },
    ],
  },
  24: {
    // component: 'CLeaveJob',
    component: 'CVIewPage',
    params: [
      {
        key: 'processId',
        value: 'processId',
      },
    ],
  },
  26: {
    component: 'CTransferDormitory',
    params: [
      {
        key: 'processId',
        value: 'processId',
      },
    ],
  },
  27: {
    // component: 'CCourseApplication',
    component: 'CVIew',
    params: [
      {
        key: 'processId',
        value: 'processId',
      },
    ],
  },
  28: {
    // component: 'CPassportApplication',
    component: 'CVIew',
    params: [
      {
        key: 'processId',
        value: 'processId',
      },
    ],
  },
  // 事务申请
  30: {
    // component: 'CWorkerForm',
    component: 'CVIew',
    params: [
      {
        key: 'processId',
        value: 'processId',
      },
    ],
  },
  // 批量课程申请
  31: {
    component: 'CCourse',
    params: [
      {
        key: 'processId',
        value: 'processId',
      },
    ],
  },
  // 37: {
  //   component: 'CSettlement',
  //   params: [
  //     {
  //       key: 'processId',
  //       value: 'settlementId',
  //     },
  //   ],
  // },

}

// 需要自定义审批页面的配置
export const processOption = {
  4: {
    component: 'CInterview',
    params: [
      {
        key: 'id',
        value: 'interviewId',
      },
    ],
  },
  32: {
    component: 'CInterview',
    params: [
      {
        key: 'id',
        value: 'interviewId',
      },
    ],
  },
  37: {
    component: 'CSettlement',
    params: [
      {
        key: 'processInstanceId',
        value: 'processInstanceId',
      },
      {
        key: 'processId',
        value: 'processId',
      },
      {
        key: 'formId',
        value: 'formId',
      },
      {
        key: 'workerId',
        value: 'worker',
      },
    ],
  },
  ...workerProcessOption,
}

// 默认自定义表单的审批页面
export const defaultProcessOption = {
  component: 'CVIewPage',
  params: [
    {
      key: 'processId',
      value: 'processId',
    },
  ],
}
// 默认编辑表单
export const defaultEditProcessOption = {
  component: 'CVEditPage',
  params: [
    {
      key: 'processId',
      value: 'processId',
    },
  ],
}

export default {
  CSettlement,
  CVIewPage,
  CInterview,
  CTurnSite,
  CLeaveJob,
  CTransferDormitory,
  CCourseApplication,
  CPassportApplication,
  CCourse,
  CVIew,
  CVEditPage,
}
